// grab elements
const noSearchResults = document.getElementById('no-search-results');
const searchForm = document.getElementById('faq-search-form');
const searchBox = document.getElementById('faq-search-keyword');
const searchButton = document.getElementById('faq-search-submit');
const searchClear = document.getElementById('faq-search-clear');
const searchSite = document.getElementById('search-site');
const searchStatus = document.getElementById('search-status');

// assign event listeners
searchForm.addEventListener('submit', (event) => {
    event.preventDefault();
    searchForText();
});

searchClear.addEventListener('click', () => {
    clearSearch();
    searchBox.value = '';
});

/**
 * Hides faq-sections, panel-headlines, and panel-contents depending on user search.
 * If the search returns no results then we display a helpful little message.
 */
function searchForText() {
    clearSearch();
    const searchContent = searchBox.value.toLowerCase();
    let countOfTotalElems = 0;
    let countOfHiddenElems = 0;

    // the amount of elements with panel-headline as a class and panel-content should always be equal
    // if neither of the headline or content contain the text we're searching for then we should hide both.
    const panels = document.querySelectorAll('details');
    for (const panel of panels) {
        if (!panel.querySelector('summary').innerText.toLowerCase().includes(searchContent) &&
            !panel.querySelector('.panel-content').innerText.toLowerCase().includes(searchContent)) {
            
            //hide this panel
            panel.classList.add('hidden-faq');
            // 1 element, the details element
            countOfHiddenElems += 1;
        }
        // 1 element, the details element
        countOfTotalElems += 1;
    }

    // cycle over the pattern--faq-accordion and grab all their children with a details tag
    // if any of those aren't hidden, then we don't hide the faq-section
    const faqSections = document.querySelectorAll('.pattern--faq-accordion');
    for (const panels of faqSections) {
        let hide = true;
        const details = panels.querySelectorAll('details');
        for (const detail of details) {
            if (!detail.classList.contains('hidden-faq')) {
                hide = false;
                break;
            }
        }
        if (hide) {
            panels.classList.add('hidden-faq');
            countOfHiddenElems++;
        }
        countOfTotalElems++;
    }

    if (countOfTotalElems === countOfHiddenElems) {
        searchSite.href = `/?s=${searchContent}`;
        noSearchResults.classList.remove('hidden');
        // Announce no results to screen readers
        searchStatus.textContent = 'No results found for your search. Please try different keywords or search the entire site.';
    } else {
        // Calculate visible results
        const visibleCount = countOfTotalElems - countOfHiddenElems;
        const panelCount = panels.length - Array.from(panels).filter(p => p.classList.contains('hidden-faq')).length;
        // Announce results to screen readers
        searchStatus.textContent = `Found ${panelCount} matching ${panelCount === 1 ? 'question' : 'questions'}.`;
    }
}

/**
 * Un-hides everything that was hidden during searching.
 * Hide helpful message.
 */
function clearSearch() {
    const elements = document.querySelectorAll('.hidden-faq');

    noSearchResults.classList.add('hidden');

    for (const element of elements) {
        element.classList.remove('hidden-faq');
    }

    // Clear status message and announce to screen readers
    if (searchBox.value) {
        const totalPanels = document.querySelectorAll('details').length;
        searchStatus.textContent = `Search cleared. Showing all ${totalPanels} questions.`;
    } else {
        searchStatus.textContent = '';
    }
}